import { Link } from '@mui/material';

import { APPOINTMENT_TYPE } from '@widget/api/types';
import { getFormattedDateString } from '@toolbox/utils';

import type { AddCalendarEventButtonProps } from './types';

const EVENT_TEXTS: { [key: string]: string } = {
  titleCall: 'Ihr Telefontermin mit McMakler',
  notesCall: 'Ihr Telefontermin zur Evaluierung Ihrer Immobilie',
  titleOnSite: 'Ihr Vororttermin mit McMakler',
  notesOnSite: 'Ihr Vororttermin zur Evaluierung Ihrer Immobilie',
};

export const AddCalendarEventButton = ({
  texts,
  bookingType,
  startTime,
  address,
}: AddCalendarEventButtonProps) => {
  const formattedDate = getFormattedDateString(startTime);

  const titleKey = bookingType === APPOINTMENT_TYPE.CALL ? 'titleCall' : 'titleOnSite';
  const notesKey = bookingType === APPOINTMENT_TYPE.CALL ? 'notesCall' : 'notesOnSite';
  const title = texts[titleKey] || EVENT_TEXTS[titleKey];
  const notes = texts[notesKey] || EVENT_TEXTS[notesKey];
  const location = bookingType === APPOINTMENT_TYPE.ON_SITE ? address : '';

  return (
    <Link
      href={`https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&location=${location}&dates=${formattedDate}&details=${notes}`}
      underline="none"
      target="_blank"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        height: '42px',
        paddingY: '10px',
        paddingX: '24px',
        backgroundColor: '#FFD700',
        alignItems: 'center',
        fontSize: '16px',
        lineHeight: 1.5,
        fontWeight: 600,
      }}
    >
      {texts.text}
    </Link>
  );
};
